import React from 'react';
import { motion } from 'framer-motion';
import { Shield, Award, Clock, MapPin, CheckCircle } from 'lucide-react';
export function TrustBar() {
  const trustSignals = [{
    icon: <Shield size={20} className="text-brand-teal" data-id="element-458" />,
    text: 'Certified Organisational Ombuds',
    verified: true
  }, {
    icon: <Award size={20} className="text-brand-teal" data-id="element-459" />,
    text: 'Nationally Accredited Mediator',
    verified: true
  }, {
    icon: <CheckCircle size={20} className="text-brand-teal" data-id="element-460" />,
    text: 'ICF Certified Coach',
    verified: true
  }, {
    icon: <Clock size={20} className="text-brand-teal" data-id="element-461" />,
    text: '20+ Years Experience',
    verified: true
  }, {
    icon: <MapPin size={20} className="text-brand-teal" data-id="element-462" />,
    text: 'Perth-Based, Australia-Wide',
    verified: false
  }];
  return <section className="py-10 bg-brand-off-white border-b border-gray-200 shadow-[0_4px_20px_-10px_rgba(0,0,0,0.05)] relative z-20" data-id="element-463">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-464">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="flex flex-col items-center" data-id="element-465">
          <p className="text-xs font-semibold text-brand-charcoal/40 uppercase tracking-widest mb-6" data-id="element-466">
            Trusted Credentials
          </p>
          <div className="flex flex-wrap items-center justify-center gap-x-10 gap-y-6" data-id="element-467">
            {trustSignals.map((signal, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: index * 0.1
          }} className="flex items-center gap-3 text-[15px] text-brand-charcoal" data-id="element-468">
                {signal.icon}
                <span className="font-semibold" data-id="element-469">{signal.text}</span>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}